<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Account Statment</h5>
            </div>
            <div class="card">
                <div style="position: relative">
                    <div class="p-px-3">
                        <div class="p-formgrid p-grid">
                            <DataTable :value="debits" :lazy="true" :paginator="true" :rows="30"
                                :totalRecords="totalRecords" :loading="loading" @page="onPage" class="p-datatable-users"
                                data-key="bd1" :rowHover="true"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                                <Toolbar>
                                    <template v-slot:right>
                                        <!-- <Button label="Filter" icon="pi pi-filter" @click="onFilter" /> -->
                                        <Button v-if="!showFillFilter" label="Filter" icon="pi pi-filter"
                                            @click="filterlisting()" class="p-mr-2"
                                            style="margin: right 3.5rem; "></Button>
                                        <Button v-if="showFillFilter" label="Filter" icon="pi pi-filter-slash"
                                            class="p-button-success p-mr-2" @click="filterlisting()"
                                            style="margin: right 3.5rem; "></Button>
                                    </template>
                                </Toolbar>
                                <template #empty> No data found. </template>
                                <template #loading> Loading data. Please wait... </template>
                                <Column field="id" header="Sr." headerStyle="width:5%">
                                    <template #body="{ index }">
                                        {{ ++index }}
                                    </template>
                                </Column>
                                <Column header="Date" field="date" headerStyle="width: 20%">
                                    <template #body="{ data }">
                                        <div v-if="data.bg7">{{ format_timestamp(data.bg7) }} </div>
                                        <div v-if="data.bg13">{{ format_timestamp(data.bg13) }} </div>
                                    </template>
                                </Column>
                                <Column header="Particular" field="bg23" headerStyle="width: 39%;"></Column>
                                <Column header="Credit" headerStyle="width: 12%" field="creditAmount">
                                    <template #body="{ data: { bg5: creditAmount } }">
                                        <div class="muted-text">
                                            {{ creditAmount ? formatCurrency(creditAmount) : 'N/A' }}
                                        </div>
                                    </template>
                                </Column>
                                <Column header="Debit" headerStyle="width: 12%" field="creditAmount">
                                    <template #body="{ data: { bg12: debitAmount } }">
                                        {{ debitAmount ? formatCurrency(debitAmount) : 'N/A' }}
                                    </template>
                                </Column>
                                <Column header="Balance" headerStyle="width: 12%" field="creditAmount">
                                    <template #body="{ data: { bg18: balance } }">
                                        {{ balance ? formatCurrency(balance) : 'N/A' }}
                                    </template>
                                </Column>
                            </DataTable>
                            <Toast />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Filter dialog start here -->
    <Dialog v-model:visible="isFilter" :style="{ width: '600px' }" header="Account Statement Filter" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-6">
                    <label for="from-date">From Date</label>
                    <Calendar :showIcon="true" :monthNavigator="true" :yearNavigator="true" v-model="filters.fromDate"
                        :maxDate="todaysDate" placeholder="DD/MM/YYYY" dateFormat="dd/mm/yy"
                        :yearRange="'2020:' + todaysDate.getFullYear()" appendTo="body" :manualInput="false"></Calendar>
                </div>
                <div class="p-field p-col-6">
                    <label for="to-date">To Date</label>
                    <Calendar :showIcon="true" :monthNavigator="true" :yearNavigator="true" v-model="filters.toDate"
                        :minDate="filters.fromDate || null" :maxDate="todaysDate" placeholder="DD/MM/YYYY"
                        dateFormat="dd/mm/yy" :yearRange="'2020:' + todaysDate.getFullYear()" appendTo="body"
                        :manualInput="false"></Calendar>
                </div>
            </div>
        </div>

        <template #footer>
            <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="reSetFilteredData()" />
            <Button label="Search" icon="pi pi-search" class="p-mr-2" autofocus @click="submitFilter" />
        </template>
        <!-- <template #footer>
            <div>
                <Button v-if="!showLoader" label="Search" icon="pi pi-search" class="p-button-text p-ml-auto"
                    @click="submitFilter" style="width: 90px"></Button>
                <Button v-show="showLoader" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                    style="width: 90px"></Button>
            </div>
        </template> -->
    </Dialog>
    <!-- Filter dialog end here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { required, helpers, numeric } from '@vuelidate/validators';
import moment from 'moment';

export default {
    data() {
        return {
            debits: [],
            v$: useValidate(),
            isAddDebit: false,
            isSubmitted: false,
            isFilter: false,
            componentName: "",
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            componentNamesList: [],
            fromDate: null,
            todaysDate: new Date(),
            remark: "",
            usedCount: "",
            filters: {
                toDate: "",
                fromDate: ""
            },
            routeParam: '',
            localAdminName: '',
            showFillFilter: false,

        };
    },
    validations() {
        return {
            componentName: { required: helpers.withMessage('Please select employee', required) },
            usedCount: { required: helpers.withMessage('Please enter used count', required), numeric: helpers.withMessage('Only numbers are allowed', numeric) },
            fromDate: { required: helpers.withMessage('Please select from date', required) },
        };
    },
    ApiService: null,
    interval: null,
    created() {
        this.ApiService = new ApiService();
    },
    mounted() {
        this.getAdminAccountStatement();
    },
    methods: {
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getAdminAccountStatement({ page_no: event.page, fromdate: this.filters.fromDate, todate: this.filters.toDate });
        },
        getAdminAccountStatement(ev) {
            this.loading = true;
            this.ApiService.getAdminAccountStatement(ev).then((data) => {
                if (data.status == 200) {
                    this.debits = data.data;
                    this.totalRecords = data.count;
                    this.isFilter = false;
                } else {
                    this.debits = '';
                    this.totalRecords = 0;
                }
                this.loading = false;
            });
        },
        reSetFilteredData() {
            this.getAdminAccountStatement();
            this.isFilter = false;
            this.filters.toDate = "";
            this.filters.fromDate = "";
            // this.showFillFilter = false;

        },
        filterlisting() {
            this.isFilter = true;
            // this.filters.toDate = "";
            // this.filters.fromDate = "";
        },
        submitFilter() {
            if (this.filters.fromDate != "" && this.filters.fromDate != null) {
                this.filters.fromDate = moment(this.filters.fromDate).format("YYYY-MM-DD");
            }
            if (this.filters.toDate != "" && this.filters.toDate != null) {
                this.filters.toDate = moment(this.filters.toDate).format("YYYY-MM-DD");
            }
            this.showFillFilter = true;
            this.getAdminAccountStatement({ fromdate: this.filters.fromDate, todate: this.filters.toDate });
        },
        onFilter() {
            this.isFilter = true;
            this.filters.toDate = "";
            this.filters.fromDate = "";
        },
        onlyNumber($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which;
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                $event.preventDefault();
            }
        },
        formatCurrency(amount, currency = 'INR', minimumFractionDigits = 2) {
            let formatterAmount = new Intl.NumberFormat('en-IN', { minimumFractionDigits }).format(amount.toString());
            return (+0).toLocaleString('en-IN', { style: 'currency', currency })
                .replace('0.00', " " + formatterAmount)
        },
        dateFormat(date, format = 'DD-MM-YYYY') {
            return moment(date).format(format)
        },
        format_datetime(value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY @ hh:mm A");
            } else {
                return '-';
            }
        },
        format_timestamp(value) {
            if (value) {
                var localTime = new Date(value * 1000).toUTCString();
                return moment(localTime).format("DD/MM/YYYY @ hh:mm A");
            } else {
                return 'N/A';
            }
        },
    }

};
</script>

<style scoped></style>
